import {abilityChoiceError} from './ability-scores';
import type {Catalog} from './catalog';
import type {Character} from './character';
import {choiceOptions} from './choice-options';
import {ChoiceInstance, FeatureInstance, flattenChoices, flattenFeatures} from './feature-tree';
import {evaluateNumber} from './formula';
import {isManagedOnSheet} from './spell-preparation';

export function choiceLimit(choice: ChoiceInstance, character: Character): number | undefined {
	const {max, change} = choice.group;
	if (max == null) return 1;
	const context = character.formulaContext(choice.owner, [choice.featureKey, choice.owner.key]);
	const limit = evaluateNumber(max, context);
	if (limit === undefined) return undefined;
	if (change === 'eachLevel') return limit * Math.max(0, choice.owner.level - choice.level);
	return limit;
}

export function isChoiceComplete(choice: ChoiceInstance, catalog: Catalog, character: Character): boolean {
	if (choice.locked) return true;
	const limit = choiceLimit(choice, character);
	if (limit === undefined) return choice.selected.length > 0;
	const required = Math.min(limit, choiceOptions(choice, catalog, character).length);
	return choice.selected.length >= required;
}

/** выборы с ошибкой: повышение характеристики не помещается в предел */
export function choicesWithErrors(features: FeatureInstance[], character: Character): ChoiceInstance[] {
	return flattenFeatures(features)
		.flatMap((instance) => flattenChoices(instance.choices))
		.filter((choice) => abilityChoiceError(choice, character.abilityOverflows));
}

export function incompleteChoices(
	features: FeatureInstance[],
	catalog: Catalog,
	character: Character,
): ChoiceInstance[] {
	return flattenFeatures(features)
		.flatMap((instance) =>
			flattenChoices(instance.choices).filter((choice) => !isManagedOnSheet(choice, instance.feature)),
		)
		.filter((choice) => !isChoiceComplete(choice, catalog, character));
}
